import * as React from 'react';
import Spinner from 'components/spinner/spinner.component';

interface IEventGrantProps {
    readonly eventApplyOwnership: () => void;
}

export class EventGrantComponent extends React.PureComponent<IEventGrantProps, {}> {
    public componentDidMount() {
        this.props.eventApplyOwnership();
    }

    public render() {
        return <Spinner />;
    }
}

export default EventGrantComponent;
